import { useMemo } from 'react';
import { CardContent, Grid } from '@mui/material';

import { Card, InfoField, JsonBlock, NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

import { LoyaltyEventPointChange } from './types';
import { parseEventData } from './utils';

type Props = {
  pointChange: LoyaltyEventPointChange;
};

export const PointChangeViewEventData = ({ pointChange }: Props) => {
  const { eventType, eventData } = pointChange.source;

  const payload = useMemo(() => parseEventData(eventData), [eventData]);

  return (
    <>
      <Card
        sx={(theme) => ({
          marginBottom: theme.spacing(1),
        })}
      >
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={3}>
              <InfoField
                label='Event Type'
                value={eventType}
                noDataMessage={NO_DATA_PLACEHOLDER}
                truncate
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card
        sx={(theme) => ({
          marginBottom: theme.spacing(1),
        })}
      >
        <CardContent>
          <JsonBlock
            sx={(theme) => ({ fontSize: theme.typography.pxToRem(12) })}
            object={payload}
          />
        </CardContent>
      </Card>
    </>
  );
};
